import React from 'react';
import {Avatar} from "antd";
import {BASE_PATH} from "../../../../../custom/axios/config/Url";

const styleBackground = {
    backgroundColor: "rgba(76, 78, 100, 0.05)"
}
const stylePadding = {
    paddingTop: 14,
    paddingBottom: 16
}
const styleMargin = {
    marginLeft: 24,
    marginRight: 10,
    marginBottom : 2
}
const styleColor = {
    color: "#344054",
    display: "flex",
    alignItems: "center"
}

function DescriptionTitle({title}) {

    return (
        <div
            className={"bg-white w-full mb-4"}
        >
            <div className="flex items-center justify-between" style={styleBackground}>
                <div style={stylePadding}>
                    {title ?
                        <h3 className={"text-[18px] m-0"} style={styleColor}>
                            <Avatar shape="square" src={`${BASE_PATH}/static-medias/logo/doTnp.png`} size={20} style={styleMargin}/>
                            {title}
                        </h3> : null}
                </div>
            </div>
        </div>
    );
}

export default DescriptionTitle;
